<template>
  <div class="wrapper">
    <div class="createTasteTeam">
      <Step0Left v-if="current === STEPS.STEP0" class="w-[40%] h-full step-0-left" />
      <Step1Left v-if="current === STEPS.STEP1" class="w-[40%] h-full" />
      <div class="flex-grow flex flex-col items-center relative">
        <Steps class="mt-[80px] mb-[40px] steps" :current="current" />
        <Step0Content v-if="current === STEPS.STEP0" @next="nextStep" />
        <Step1Content v-if="current === STEPS.STEP1" @login="onLogin" />
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import Step0Left from './components/ContentLeft.vue';
import Step0Content from './components/taste/step0/content.vue';
import Step1Content from './components/taste/step1/content.vue';
import Step1Left from './components/taste/step1/left.vue';

import { getUserToken } from '~/api';
import type { LoginInfo, UserInfo } from '~/api/interface';
import { BROADCAST_KEY } from '~/constants/config';
import { STEPS, TEAM_TASTE_PAY_YANBI_KEY } from '~/constants/teamCreate';
import { buriedLogin } from '~/utils/track';
import Steps from './components/taste/steps/index.vue';

const route = useRoute();
const router = useRouter();
const session = useSession();
const { setSession } = useChangeUser();

const current = ref<STEPS>(Number(route.query.step) || STEPS.STEP0);

const userInfo = useUserInfo();

watch(
  () => route.query.step,
  step => {
    current.value = Number(step) || STEPS.STEP0;
  },
  { immediate: true },
);

watch(
  () => session.value,
  user => {
    if (!user?.user_id && current.value !== STEPS.STEP0) {
      router.replace({
        query: { step: STEPS.STEP0 },
        name: route.name as string,
      });
    }
  },
  { immediate: true },
);

function nextStep() {
  router.push({
    query: { step: current.value + 1 },
    name: route.name as string,
  });
}

function updateCustomSetting(userInfo: any) {
  CustomSettingApp.initAvatar(userInfo.logo_url, userInfo.default_logo_url);
  CustomSettingApp.initLogo(userInfo.platform_logo_url, userInfo.default_platform_logo_url);
}

async function onLogin(info: UserInfo) {
  sessionSetItem(TEAM_TASTE_PAY_YANBI_KEY, info);
  userInfo.value = info;
  const { data } = await getUserToken(info.user_id); // 获取LoginInfo
  const account = data?.[0] as LoginInfo;

  buriedLogin(Number(account.user_id));

  await setSession(account); // 更新当前账户

  updateCustomSetting(account); // 更新头像和logo

  emitBroadcast(BROADCAST_KEY.REFRESH, { tabId: TAB_ID });

  location.href = '/workspace';
}
</script>
<style lang="scss" scoped>
.wrapper {
  height: 100%;
  width: 100vw;
  overflow: auto;
  background: var(--create-wrapper-bg);
}

.createTasteTeam {
  display: flex;
  width: 100%;
  height: 100%;
  overflow-x: hidden;

  background: var(--create-wrapper-bg);
  .steps {
    width: min(80%, 800px);
  }
}
</style>
